import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CompanyAdministrativeService } from 'src/app/services/company-administrative.service';
import { CompanyService } from 'src/app/services/company.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CompanyResponse } from 'src/app/models/company.model';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { HttpErrorResponse } from '@angular/common/http';
import { UserSaved } from 'src/app/models/user.model';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { SimplePaginationModel } from 'src/app/models/pagination.model';

@Component({
  selector: 'app-administrative-companies',
  templateUrl: './administrative-companies.component.html',
  styleUrls: ['./administrative-companies.component.scss']
})
export class AdministrativeCompaniesComponent {
  allAdministrativeCompanies: CompanyResponse[] = [];
  allFiscalCompanies: any[] = [];

  administrativeCompanies: CompanyResponse[] = [];
  fiscalCompanies: CompanyResponse[] = [];

  administrativeId: string | null = null;
  fiscalId: string | null = null;

  filterAdministrative: string = '';
  filterFiscal: string = '';

  buttonAssociate: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");

  user: UserSaved = null;
  companies = []

  paginationAdministrative = new SimplePaginationModel(0, 5, 0, 0, 0);
  paginationFiscal = new SimplePaginationModel(0, 5, 0, 0, 0);

  relatedCompanyIds: number[] = [];

  selectedAdministrativeId: number | null = null;
  initialRelatedIds: number[] = []; // Estado original al seleccionar
  currentRelatedIds: number[] = []; // Estado actual del usuario

  newAssociations: number[] = [];
  removedAssociations: number[] = [];


  @ViewChild('svgContainer', { static: true }) svgContainer: ElementRef;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.drawLink();
  }

  constructor(
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private companyService: CompanyService,
    private companyAdministrativeService: CompanyAdministrativeService
  ) {
    this.companies = JSON.parse(this.authService.getCurrentUser()).companyRoles;
    this.allFiscalCompanies = this.companies.filter(c => !c.administrative);
    this.user = this.authService.getUser();
  }

  ngOnInit(): void {
    this.getStartData();
  }

  getStartData(){
    this.loadAdministrativeCompanies();
    if (this.user.contadorGT) {
      this.loadFiscalCompanies();
    }
    this.refreshFiscalPagination();
    this.refreshAdministrativePagination();
  }

  loadAdministrativeCompanies() {
    this.companyAdministrativeService.getAllCompaniesAdministrative().subscribe({
      next: (response: ResponseObject) => {
        this.allAdministrativeCompanies = response.data;
        this.refreshAdministrativePagination();
      },
      error: () => this.toastService.error("Error al obtener las empresas administrativas")
    });
  }

  loadFiscalCompanies() {
    const user = this.authService.getUser();
    this.companyService.getCompaniesAssociatedToPartner(user.id).subscribe({
      next: (response: ResponseObject) => {
        this.allFiscalCompanies = response.data.filter(c => !c.administrative);
        this.refreshFiscalPagination();
      },
      error: () => this.toastService.error("Error al obtener las empresas fiscales")
    });
  }

  getRelationsByCompany(companyId: string, type: 'administrative' | 'fiscal') {
    this.companyAdministrativeService.getRelatedCompaniesByCompany(companyId).subscribe({
      next: (response: ResponseObject) => {
        this.relatedCompanyIds = response.data;

        this.selectedAdministrativeId = parseInt(companyId);
        this.initialRelatedIds = [...response.data]; // copia para comparar
        this.currentRelatedIds = [...response.data]; // estado editable

        this.drawMultipleLinks(companyId, this.currentRelatedIds, type);
        this.refreshFiscalPagination();
      },
      error: () => this.toastService.error("Error al obtener las relaciones de la empresa")
    });
  }

  toggleFiscalRelation(fiscalId: number) {
    const index = this.currentRelatedIds.indexOf(fiscalId);
    if (index === -1) {
      this.currentRelatedIds.push(fiscalId); // agregar
    } else {
      this.currentRelatedIds.splice(index, 1); // quitar
    }

    this.drawMultipleLinks(this.selectedAdministrativeId.toString(), this.currentRelatedIds, 'administrative');
  }


  
  drawMultipleLinks(selectedId: string, relatedIds: number[], selectedType: 'administrative' | 'fiscal') {
    const svg = this.svgContainer.nativeElement as SVGElement;
    svg.innerHTML = '';

    setTimeout(() => {
      const parentRect = svg.parentElement.getBoundingClientRect();

      // Obtenemos coordenadas de la empresa seleccionada
      const selector = selectedType === 'administrative' ? '#table-administrative' : '#table-fiscal';
      const selectedRow = document.querySelector(`${selector} tr.selected`);
      if (!selectedRow) return;

      const selectedRect = selectedRow.getBoundingClientRect();
      const x1 = selectedRect.right - parentRect.left - 12;
      const y1 = selectedRect.top + selectedRect.height / 2 - parentRect.top;

      // Dibujar línea hacia cada empresa relacionada
      for (const relatedId of relatedIds) {
        const relatedSelector = selectedType === 'administrative'
          ? `#table-fiscal tr[data-id="${relatedId}"]`
          : `#table-administrative tr[data-id="${relatedId}"]`;

        const relatedRow = document.querySelector(relatedSelector);
        if (!relatedRow) continue;

        const rect = relatedRow.getBoundingClientRect();
        const x2 = rect.left - parentRect.left - 12;
        const y2 = rect.top + rect.height / 2 - parentRect.top;
        const xMiddle = x1 + ((x2 - x1) / 2);

        this.drawLine(svg, x1, xMiddle, y1, y1);
        this.drawLine(svg, xMiddle, x2, y2, y2);
        this.drawLine(svg, xMiddle, xMiddle, y1, y2);
      }
    }, 50);
  }



  selectRow(type: 'administrative' | 'fiscal', id: string) {
    if (type === 'administrative') {
      this.administrativeId = id;
      //this.fiscalId = null;
      this.getRelationsByCompany(id, type);
    } else {
      this.fiscalId = id;
      //this.administrativeId = null;
    }

    
    // this.drawLink();
  }

  drawLink() {
    const svg = this.svgContainer.nativeElement as SVGElement;
    svg.innerHTML = '';

    if (!this.administrativeId || !this.fiscalId) return;

    setTimeout(() => {
      const adminRow = document.querySelector(`#table-administrative tr.selected`);
      const fiscalRow = document.querySelector(`#table-fiscal tr.selected`);
      const parentRect = svg.parentElement.getBoundingClientRect();

      if (adminRow && fiscalRow) {
        const rect1 = adminRow.getBoundingClientRect();
        const rect2 = fiscalRow.getBoundingClientRect();

        const x1 = rect1.right - parentRect.left - 12;
        const y1 = rect1.top + rect1.height / 2 - parentRect.top;
        const x2 = rect2.left - parentRect.left - 12;
        const y2 = rect2.top + rect2.height / 2 - parentRect.top;
        const xMiddle = x1 + (x2 - x1) / 2;

        this.drawLine(svg, x1, xMiddle, y1, y1);
        this.drawLine(svg, xMiddle, x2, y2, y2);
        this.drawLine(svg, xMiddle, xMiddle, y1, y2);
      }
    }, 50);
  }

  drawLine(svg: SVGElement, x1: number, x2: number, y1: number, y2: number) {
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', x1.toString());
    line.setAttribute('y1', y1.toString());
    line.setAttribute('x2', x2.toString());
    line.setAttribute('y2', y2.toString());
    line.setAttribute('stroke', '#001f54');
    line.setAttribute('stroke-width', '2');
    svg.appendChild(line);
  }

  associateCompanies() {
    if (!this.administrativeId || !this.fiscalId || this.buttonAssociate.loading) return;

    this.buttonAssociate.loading = true;

    this.companyAdministrativeService.associateCompanies(
      parseInt(this.administrativeId),
      parseInt(this.fiscalId)
    ).subscribe({
      next: () => {
        this.toastService.success('Empresas asociadas correctamente');
        this.buttonAssociate.loading = false;
        this.administrativeId = null;
        this.fiscalId = null;
        this.loadAdministrativeCompanies();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message || 'Error al asociar las empresas');
        this.buttonAssociate.loading = false;
      }
    });
    this.buttonAssociate.loading = false;
  }

  timeoutAdmin = null;
  writeAdministrative() {
    clearTimeout(this.timeoutAdmin);
    this.timeoutAdmin = setTimeout(() => {
      this.paginationAdministrative.page = 0;
      this.refreshAdministrativePagination();
    }, 300);
  }

  timeoutFiscal = null;
  writeFiscal() {
    clearTimeout(this.timeoutFiscal);
    this.timeoutFiscal = setTimeout(() => {
      this.paginationFiscal.page = 0;
      this.refreshFiscalPagination();
    }, 300);
  }

  refreshAdministrativePagination() {
    const filtered = this.allAdministrativeCompanies.filter(c =>
      c.name.toLowerCase().includes(this.filterAdministrative.toLowerCase()) ||
      c.nit.toLowerCase().includes(this.filterAdministrative.toLowerCase())
    );

    this.paginationAdministrative.total = filtered.length;
    this.paginationAdministrative.start = this.paginationAdministrative.page * this.paginationAdministrative.size;
    const end = this.paginationAdministrative.start + this.paginationAdministrative.size;
    this.paginationAdministrative.end = Math.min(end, filtered.length);
    this.administrativeCompanies = filtered.slice(
      this.paginationAdministrative.start,
      this.paginationAdministrative.end
    );
  }

  refreshFiscalPagination() {
    const filtered = this.allFiscalCompanies.filter(c => {
      const name = c.name || c.companyName || '';
      const nit = c.nit || c.companyNIT || '';
      return (
        name.toLowerCase().includes(this.filterFiscal.toLowerCase()) ||
        nit.toLowerCase().includes(this.filterFiscal.toLowerCase())
      );
    });

    this.paginationFiscal.total = filtered.length;
    this.paginationFiscal.start = this.paginationFiscal.page * this.paginationFiscal.size;
    const end = this.paginationFiscal.start + this.paginationFiscal.size;
    this.paginationFiscal.end = Math.min(end, filtered.length);
    filtered.sort((a, b) => {
      const aId = a.id || a.companyId;
      const bId = b.id || b.companyId;
      const aRelated = this.currentRelatedIds.includes(aId) ? 0 : 1;
      const bRelated = this.currentRelatedIds.includes(bId) ? 0 : 1;
      return aRelated - bRelated;
    });

    this.fiscalCompanies = filtered.slice(
      this.paginationFiscal.start,
      this.paginationFiscal.end
    );
    if (this.selectedAdministrativeId && this.currentRelatedIds.length > 0) {
      this.drawMultipleLinks(this.selectedAdministrativeId.toString(), this.currentRelatedIds, 'administrative');
    }
  }

  saveAssociations() {
    if (!this.selectedAdministrativeId) return;

    const initialSet = new Set(this.initialRelatedIds);
    const currentSet = new Set(this.currentRelatedIds);

    // Nuevas relaciones: están en current pero no en initial
    this.newAssociations = this.currentRelatedIds.filter(id => !initialSet.has(id));

    // Eliminadas: están en initial pero no en current
    this.removedAssociations = this.initialRelatedIds.filter(id => !currentSet.has(id));

    this.buttonAssociate.loading = true;

    const requests = [];

    for (const fiscalId of this.newAssociations) {
      requests.push(this.companyAdministrativeService.associateCompanies(this.selectedAdministrativeId, fiscalId));
    }

    for (const fiscalId of this.removedAssociations) { // TODO: Eliminar
      console.log("Remove", fiscalId);
      console.log("Remove", this.selectedAdministrativeId);
      requests.push(this.companyAdministrativeService.removeAssociation(this.selectedAdministrativeId, fiscalId));
    }

    if (requests.length === 0) {
      this.toastService.info("No hay cambios por guardar.");
      this.buttonAssociate.loading = false;
      return;
    }

    Promise.all(requests.map(req => req.toPromise())).then(() => {
      this.toastService.success("Cambios guardados exitosamente");
      this.buttonAssociate.loading = false;
      this.getRelationsByCompany(this.selectedAdministrativeId.toString(), 'administrative');
    }).catch(() => {
      this.toastService.error("Error al guardar cambios");
      this.buttonAssociate.loading = false;
    });
  }


}
